import React, { useRef, useState } from 'react'
import { PropTypes } from 'prop-types'
import { useTranslation } from 'react-i18next'
import useOutsideClick from 'hooks/useOutsideClick'

function DropDown({ variant }) {
  const { t, i18n } = useTranslation()

  const AVAILABLE_LANGUAGES = Object.keys(i18n.services.resourceStore.data)
  const fallbackLanguage = AVAILABLE_LANGUAGES.includes(i18n.language) ? i18n.language : 'en'

  const selectReft = useRef()
  const [language, setLanguage] = useState(fallbackLanguage)
  const [selected, setSelected] = useState(t(`settings.${fallbackLanguage}`))
  const [showMenu, setShowMenu] = useState(false)

  const options = [
    { value: 'en', label: t('settings.en') },
    { value: 'cn', label: t('settings.cn') },
    { value: 'tr', label: t('settings.tr') }
  ]

  const hide = () => setShowMenu(false)

  const changeLanguage = (e) => {
    i18n.changeLanguage(e)
    setLanguage(e)
  }

  const handlerShowOptions = () => {
    setShowMenu((old) => !old)
  }

  function handleKeyDown(e) {
    if (e.keyCode === 13) {
      handlerShowOptions()
    }
  }

  function handlerOption(option) {
    setSelected(option.label)
    changeLanguage(option.value)
    hide()
  }

  useOutsideClick(selectReft, () => {
    if (showMenu) hide()
  })

  return (
    <div ref={selectReft} className={`dropdown ${variant}`}>
      <span className="dropdown-world" onClick={handlerShowOptions} />
      <div
        className={showMenu ? 'dropdown-btn dropdown-btn--active' : 'dropdown-btn'}
        onClick={handlerShowOptions}
        role="button"
        tabIndex={0}
        onKeyDown={handleKeyDown}
      >
        {selected}
        <div className="separator" />
      </div>
      <span className="dropdown-vector" onClick={handlerShowOptions} />
      {showMenu && (
        <div className="dropdown-content">
          {options.map((option) =>
            option.value !== language ? (
              <div
                onClick={() => handlerOption(option)}
                className="dropdown-item"
                role="button"
                tabIndex={0}
                onKeyDown={handleKeyDown}
              >
                {option.label}
              </div>
            ) : (
              ''
            )
          )}
        </div>
      )}
    </div>
  )
}

DropDown.propTypes = {
  variant: PropTypes.string.isRequired
}

export default DropDown
